export default {"src":"/_next/static/media/mail_white.eccc1e81.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};